export const ADD_TO_CART = "add to cart"
export const COLOR_SELECTION = "color selection"
export const INCLUDE_SELECT = "include select "
export const SILDER_BUNDLE_IMAGE_CLICK = "slider bundle image click"
export const PDP = "pdp"
export const PRODUCT_DETAILS = "product details"
export const BUNDLE = "bundle"
export const SPECS = "specs"
export const VIEW_MORE = "view more"
export const MOUSEOVER = "mouseover"
export const ACCORDIAN = "accordion"
export const PRINT = "print"
export const SHARE = "share"
export const BREADCRUMB = "breadcrumb"
export const STICKY_NAV = "sticky nav"
export const HEADER = "header"
